var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { VerdantColorSchemes } from "../../../types/theme";
import { isVerdantColorScheme } from "../../../utils/guards";
export var DISABLED_HIGH_EMPHASIS_STYLES = {
    backgroundColor: "background-disabled",
    borderColor: "transparent",
    color: "content-disabled",
    opacity: 1,
};
export var DISABLED_LOW_EMPHASIS_STYLES = {
    backgroundColor: "transparent",
    borderColor: "transparent",
    color: "content-disabled",
    opacity: 1,
};
var LOADING_STYLES = { opacity: 1, pointerEvents: "none" };
export var highEmphasisStyles = function (_a) {
    var colorScheme = _a.colorScheme, selected = _a.selected, isLoading = _a.isLoading;
    var styles;
    var isColorScheme = isVerdantColorScheme(colorScheme);
    var isSelected = selected && !isLoading;
    var disabledStyles = isLoading
        ? LOADING_STYLES
        : DISABLED_HIGH_EMPHASIS_STYLES;
    if (isColorScheme) {
        var interactive = {
            color: "".concat(colorScheme, "-on-base"),
            backgroundColor: "hover-".concat(colorScheme, "-high-emphasis"),
            borderColor: "transparent",
            _disabled: disabledStyles,
        };
        styles = {
            color: isSelected ? "".concat(colorScheme, "-on-bold") : "".concat(colorScheme, "-on-base"),
            backgroundColor: isSelected
                ? "".concat(colorScheme, "-bold")
                : "".concat(colorScheme, "-base"),
            borderColor: "transparent",
            _hover: interactive,
            _active: interactive,
            _focus: interactive,
        };
    }
    else {
        var interactive = {
            color: "primary-on-base",
            backgroundColor: "hover-base-high-emphasis",
            borderColor: "transparent",
            _disabled: disabledStyles,
        };
        styles = {
            color: isSelected ? "primary-on-bold" : "primary-on-base",
            backgroundColor: isSelected ? "primary-bold" : "primary-base",
            borderColor: "transparent",
            _hover: interactive,
            _active: interactive,
            _focus: interactive,
        };
    }
    return __assign(__assign({}, styles), { _disabled: disabledStyles });
};
export var mediumEmphasisStyles = function (_a) {
    var colorScheme = _a.colorScheme, selected = _a.selected, isLoading = _a.isLoading;
    var styles;
    var isColorScheme = isVerdantColorScheme(colorScheme);
    var isSelected = selected && !isLoading;
    var disabledStyles = isLoading
        ? LOADING_STYLES
        : DISABLED_LOW_EMPHASIS_STYLES;
    if (isColorScheme) {
        var color = "".concat(colorScheme, "-on-subtle");
        if (isSelected)
            color = "".concat(colorScheme, "-on-base");
        var interactive = {
            color: "".concat(colorScheme, "-on-subtle"),
            borderColor: "transparent",
            backgroundColor: "hover-".concat(colorScheme, "-medium-emphasis"),
            _disabled: disabledStyles,
        };
        styles = {
            color: color,
            backgroundColor: isSelected
                ? "".concat(colorScheme, "-base")
                : "".concat(colorScheme, "-subtle"),
            borderColor: "transparent",
            _hover: interactive,
            _active: interactive,
            _focus: interactive,
        };
    }
    else {
        var interactive = {
            color: "accent-on-subtle",
            backgroundColor: "hover-base-medium-emphasis",
            borderColor: "transparent",
            _disabled: disabledStyles,
        };
        styles = {
            color: isSelected ? "accent-on-base" : "accent-on-subtle",
            backgroundColor: isSelected ? "accent-base" : "accent-subtle",
            borderColor: "transparent",
            _hover: interactive,
            _active: interactive,
            _focus: interactive,
        };
    }
    return __assign(__assign({}, styles), { _disabled: disabledStyles });
};
export var lowEmphasisStyles = function (_a) {
    var colorScheme = _a.colorScheme, selected = _a.selected, isLoading = _a.isLoading;
    var styles;
    var isColorScheme = isVerdantColorScheme(colorScheme);
    var isSelected = selected && !isLoading;
    var disabledStyles = isLoading
        ? LOADING_STYLES
        : DISABLED_LOW_EMPHASIS_STYLES;
    if (isColorScheme) {
        var color = "".concat(colorScheme, "-base");
        if (colorScheme === VerdantColorSchemes.warning)
            color = "warning-bold";
        if (isSelected)
            color = "".concat(colorScheme, "-on-subtle");
        var interactive = {
            color: colorScheme === VerdantColorSchemes.warning
                ? "warning-bold"
                : "".concat(colorScheme, "-base"),
            backgroundColor: "hover-base-low-emphasis",
            _disabled: disabledStyles,
        };
        styles = {
            borderWidth: "v-width-thin",
            borderColor: "border-interactive",
            backgroundColor: isSelected ? "".concat(colorScheme, "-subtle") : "transparent",
            color: color,
            _hover: interactive,
            _active: interactive,
            _focus: interactive,
        };
    }
    else {
        var interactive = {
            color: "accent-base",
            backgroundColor: "hover-base-low-emphasis",
            _disabled: disabledStyles,
        };
        styles = {
            borderColor: "border-interactive",
            backgroundColor: isSelected ? "accent-subtle" : "transparent",
            color: isSelected ? "accent-on-subtle" : "accent-base",
            _hover: interactive,
            _active: interactive,
            _focus: interactive,
        };
    }
    return __assign(__assign({}, styles), { _disabled: disabledStyles });
};
export var noEmphasisStyles = function (_a) {
    var colorScheme = _a.colorScheme, selected = _a.selected, isLoading = _a.isLoading;
    var styles;
    var isColorScheme = isVerdantColorScheme(colorScheme);
    var isSelected = selected && !isLoading;
    var disabledStyles = isLoading
        ? LOADING_STYLES
        : DISABLED_LOW_EMPHASIS_STYLES;
    if (isColorScheme) {
        var color = "".concat(colorScheme, "-base");
        if (colorScheme === VerdantColorSchemes.warning)
            color = "warning-bold";
        if (isSelected)
            color = "".concat(colorScheme, "-on-base");
        var interactive = {
            color: colorScheme === VerdantColorSchemes.warning
                ? "warning-bold"
                : "".concat(colorScheme, "-base"),
            backgroundColor: "hover-base-low-emphasis",
            borderColor: "transparent",
            _disabled: disabledStyles,
        };
        styles = {
            color: color,
            backgroundColor: isSelected ? "".concat(colorScheme, "-base") : "transparent",
            borderColor: "transparent",
            _hover: interactive,
            _active: interactive,
            _focus: interactive,
        };
    }
    else {
        var interactive = {
            color: "primary-base",
            backgroundColor: "hover-base-low-emphasis",
            borderColor: "transparent",
            _disabled: disabledStyles,
        };
        styles = {
            color: isSelected ? "primary-on-base" : "primary-base",
            backgroundColor: isSelected ? "primary-base" : "transparent",
            borderColor: "transparent",
            _hover: interactive,
            _active: interactive,
            _focus: interactive,
        };
    }
    return __assign(__assign({}, styles), { _disabled: disabledStyles });
};
export var textStyles = function (_a) {
    var colorScheme = _a.colorScheme, selected = _a.selected, isLoading = _a.isLoading;
    var styles;
    var isColorScheme = isVerdantColorScheme(colorScheme);
    var isSelected = selected && !isLoading;
    var disabledStyles = isLoading
        ? LOADING_STYLES
        : DISABLED_LOW_EMPHASIS_STYLES;
    if (isColorScheme) {
        var color = "".concat(colorScheme, "-base");
        if (colorScheme === VerdantColorSchemes.warning)
            color = "warning-bold";
        if (isSelected)
            color = "".concat(colorScheme, "-on-subtle");
        var interactive = {
            color: colorScheme === VerdantColorSchemes.warning
                ? "warning-bold"
                : "".concat(colorScheme, "-base"),
            backgroundColor: "hover-base-low-emphasis",
            borderColor: "transparent",
            _disabled: disabledStyles,
        };
        styles = {
            color: color,
            backgroundColor: isSelected ? "".concat(colorScheme, "-subtle") : "transparent",
            borderColor: "transparent",
            _hover: interactive,
            _active: interactive,
            _focus: interactive,
        };
    }
    else {
        var interactive = {
            color: "primary-base",
            backgroundColor: "hover-base-low-emphasis",
            borderColor: "transparent",
            _disabled: disabledStyles,
        };
        styles = {
            color: isSelected ? "primary-on-subtle" : "primary-base",
            backgroundColor: isSelected ? "primary-subtle" : "transparent",
            borderColor: "transparent",
            _hover: interactive,
            _active: interactive,
            _focus: interactive,
        };
    }
    return __assign(__assign({}, styles), { _disabled: disabledStyles });
};
export var ButtonVariants = {
    "v-high-emphasis": highEmphasisStyles,
    "v-medium-emphasis": mediumEmphasisStyles,
    "v-low-emphasis": lowEmphasisStyles,
    "v-no-emphasis": noEmphasisStyles,
    "v-text": textStyles,
};
export var TagClickableVariants = {
    "v-medium-emphasis-tag": function (props) {
        var styles = mediumEmphasisStyles(props);
        var disabledStyles = props.isLoading
            ? LOADING_STYLES
            : DISABLED_HIGH_EMPHASIS_STYLES;
        var interactive = __assign(__assign({}, styles["_hover"]), { _disabled: disabledStyles });
        return __assign(__assign({}, styles), { _disabled: disabledStyles, _hover: interactive, _active: interactive, _focus: interactive });
    },
};
